
import AlignRight from "../../../assets/duotone/AlignRight.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AlignRightIcon({ className, dataTestid = "AlignRightIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <AlignRight data-testid={dataTestid} className={classes} {...rest} />
  );
}
